export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7666.a21619b6.jpg";